export { default } from './TabPanel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TabPanel/index.js
// module id = 380
// module chunks = 0